var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "emailTestConfigurationModal",
        size: "md",
        "hide-header-close": "",
        "no-stacking": "",
        title: _vm.$t("admin.configuration_test"),
      },
      on: {
        hide: function ($event) {
          return _vm.resetValues()
        },
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function ({ cancel }) {
            return [
              _c(
                "b-button",
                {
                  attrs: { size: "md", variant: "secondary" },
                  on: {
                    click: function ($event) {
                      return cancel()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("message.close")))]
              ),
              _c(
                "b-button",
                {
                  attrs: { size: "md", variant: "primary" },
                  on: {
                    click: function ($event) {
                      ;[_vm.testConfiguration(), cancel()]
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("admin.perform_test")))]
              ),
            ]
          },
        },
      ]),
    },
    [
      _c("b-validated-input-group-form-input", {
        attrs: {
          id: "email-to-address",
          label: _vm.$t("admin.email_address"),
          "input-group-size": "mb-3",
          rules: "required",
          type: "email",
          tooltip:
            "Enter an email address you control to test your send configuration.",
          lazy: "true",
        },
        model: {
          value: _vm.emailAddress,
          callback: function ($$v) {
            _vm.emailAddress = $$v
          },
          expression: "emailAddress",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }